<template>
  <div class="ups-header--container">

    <div class="ups-header--left">
      <img src="../../assets/img/logo-UPS.png" alt="" class="ups-header__logo">
      <h1 class="ups-header__title">{{ title }}</h1>
    </div>

    <div class="ups-header--right">
      <!-- <search class="ups-header__search" /> -->
      <el-popover
        v-if="isAdmin"
        v-model="isShowProfile"
        placement="bottom"
        title=""
        width="250px"
        trigger="click"
        popper-class="ups-header-popover"
      >
        <!--<div>-->
        <div class="ups-header--right-name">
          <img class="icon righr-img" src="../../assets/img/icon-id.png" />
          <span class="righr-label">员工ID</span>
          <span class="right-staff">{{ userinfo.userName }}</span>
        </div>
        <div class="ups-header--right-email">
          <img class="icon righr-img" src="../../assets/img/icon-email.png" />
          <span class="righr-label">邮箱</span>
          <span class="right-staff">{{ userinfo.staffEmail }}</span>
        </div>
        <!-- <div class="ups-header--right-line"></div> -->
        <!-- <a v-if="!isTranfer" class="ups-header--right-link" @click="modifyPsw">修改密码</a> -->
        <!--</div>-->
        <template #reference>
          <img src="../../assets/img/icon_user.png" class="ups-header--right-img" />
        </template>
      </el-popover>
      <div v-else class="ups-header__user">
        <!-- <el-icon class="el-icon-s-custom ups-header__user-icon"></el-icon> -->
        <img src="../../assets/img/icon_user.png" class="ups-header--right-img" />
      </div>
      <span v-if="isAdmin" class="ups-header__department">{{ userinfo.userName }}</span>
      <span v-if="isAdmin" class="vertical-line"></span>
      <span class="ups-header__department">{{ userinfo.department }}</span>
      <span class="vertical-line"></span>
      <span class="upload-icon" @click="showDrawerFunc">
        <el-tooltip class="item-tooltip" effect="dark" placement="bottom">
          <template #content>
            <div class="item-tooltip-content">
              <div class="item-tooltip-label">上传模板详情</div>
              <div class="item-tooltip-data">查看上传文件历史数据</div>
            </div>
          </template>
          <el-badge :value="unconfirmValue" :max="9" :hidden="unconfirmValue===0" class="item">
            <el-icon><Upload /></el-icon>
          </el-badge>
        </el-tooltip>
      </span>
      <span class="vertical-line"></span>
      <span class="ups-header__logout" type="text" @click="logout">退出</span>
    </div>

    <div v-if="hasUploadShow" :class="{'has-upload': true, 'has-upload-draft': isDraft}">
      <div class="flex-info">
        <img src="@/assets/img/customer/success@2x.png" class="success-icon">
        <div>
          <div class="success-text">上传完成！</div>
          <p class="success_p">{{ getTotalString() }}</p>
          <div class="has-upload_content flex-info">
            <div>
              <span v-if="detailInfo.isFixed || detailInfo.isRowData">{{ `成功新增${detailInfo.ticketSuccess}票报关单，` }}</span>
              <span>成功新增{{ detailInfo ? detailInfo.success : 0 }}{{ unit }}，重复上传{{ detailInfo ? detailInfo.repeat : 0 }}{{ unit }}，</span>
              <strong>异常{{ detailInfo ? detailInfo.abnormal : 0 }}{{ unit }}</strong>
            </div>
            <div class="flex-info detail-btn" :class="{'flex-info detail-btn-disable': detailInfo.abnormal === 0 && detailInfo.repeat === 0}">
              <div @click="gotoDetail">查看结果</div>
              <img v-if="detailInfo.abnormal === 0 && detailInfo.repeat === 0" src="@/assets/img/customer/jiantou_hui@2x.png" class="detail-icon">
              <img v-else src="@/assets/img/customer/jiantou@2x.png" class="detail-icon">
            </div>
          </div>
          <div class="btm_info">您有{{ unconfirmValue }}条上传结果未查看，请点击<span @click="showHistory">上传历史记录</span>进行查看</div>
        </div>
      </div>
      <img class="has-upload_close" src="@/assets/img/customer/upload-close@2x.png" @click="hasUploadClose">
    </div>

    <el-drawer
      :model-value="showDrawer"
      title="批量创建记录"
      direction="rtl"
      @closed="drawerClosed">
      <div class="drawer-details">
        <UploadHistoryDialog v-if="showDrawer" ref="UploadHistoryDialog" :show-drawer="showDrawer" @changeShowDrawer="changeShowDrawer"></UploadHistoryDialog>
      </div>
    </el-drawer>

    <ResultDialog ref="resultDialogRef"></ResultDialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import request from '@/request'
import { ElMessage } from 'element-plus'
import cacheSessionStorage from '@/store/cache/cacheSessionStorage'
import cacheInLocalStorage from '@/store/cache/cacheInLocalStorage'
import UploadHistoryDialog from '@/views/customers/customs-clearance/list/child/UploadHistoryDialog.vue'
import ResultDialog from '@/views/customers/customs-clearance/list/child/ResultDialog.vue'
// import Search from '@/components/HeaderSearch'

const UN_PROCESSCED = '3'
const FAIL = '0'
const INVALID = '2'

export default {
  components: { UploadHistoryDialog, ResultDialog },
  props: {
    isAdmin: {
      type: Boolean,
      default: undefined
    },
    isTranfer: {
      type: Boolean,
      default: undefined
    }
  },
  data() {
    return {
      title: 'UPS Easy Clear™智能报关管理系统',
      notifyStatus: {
        // title: '',
        // message: '请您耐心等待',
        success: 0,
        fail: 0,
        customClass: 'hide-close',
        iconClass: 'el-icon-time',
        type: '',
        id: ''
      },
      isuploadFile: false,
      filterArr: [],
      apiTimer: null,
      showDrawer: false,
      unconfirmValue: 0,
      notifyVal: null,
      comeinIndex: 0,
      hasUploadShow: false,
      exceptionNum: 0,
      unit: '条',
      detailId: '',
      detailInfo: null,
      filesTotal: 0,
      isShowProfile: false
    }
  },
  computed: {
    ...mapGetters({
      userinfo: 'user/userinfo',
      role: 'user/role'
    }),
    isDraft: {
      get() {
        if (!this.detailInfo) return false
        if (!this.detailInfo.isFixed && !this.detailInfo.isRowData) {
          return true
        }
        return false
      }
    }
  },
  watch: {
    '$root.isuploadFile': {
      deep: true,
      handler: function(val) {
        if (val) {
          this.open()
        }
      }
    },
    '$root.isHistory': {
      deep: true,
      handler: function(val) {
        if (val) {
          this.showDrawer = val
        }
      }
    }
  },
  created() {
    // console.log('userinfo:', this.userinfo)
    // console.log('HEADER=>role-created:', this.role)
    // window.gotoDetail = this.gotoDetail
  },
  beforeUnmount() {
    if (this.apiTimer) {
      clearInterval(this.apiTimer)
    }
    this.$root.isHistory = false
  },
  mounted() {
    const isB = cacheInLocalStorage.get('isB')
    const isEasyClearIdLogin = cacheInLocalStorage.get('isEasyClearIdLogin')
    if (!isB && !isEasyClearIdLogin) { // C端 ups id登录
      this.getUpsId()
    }
    this.getUnconfirm()
  },
  methods: {
    ...mapMutations({
      SET_INFO: 'user/SET_INFO'
    }),
    ...mapActions({
      GET_INFO_CUSTOMER: 'user/GET_INFO_CUSTOMER'
    }),
    getUpsId() { // ups id登录后获取ups id
      request({
        url: '/api/v1/ups-id',
        method: 'GET'
      }).then(res => {
        const decodeRes = unescape(res.replace(/\\u/g, '%u'))
        cacheInLocalStorage.set('upsId', decodeRes)
        this.saveUserInfo(decodeRes)
      })
    },
    saveUserInfo(id) { // ups id登录后保存用户信息
      request({
        url: '/api/v1/custom-profile',
        method: 'POST',
        data: {
          isFromUps: '1',
          upsId: id
        }
      }).then(res => {
        this.GET_INFO_CUSTOMER()
      })
    },
    // open(from) {
    //   if (this.filterArr.length > 0 && from === 'api') { // 上传完成
    //     this.notifyStatus.customClass = 'show-close'
    //     this.notifyStatus.iconClass = ''
    //     this.notifyStatus.type = 'success'
    //     this.notifyStatus.title = 'success'
    //     const notifyTimer = []
    //     this.filterArr.forEach((item, index) => {
    //       notifyTimer.push(index)
    //       notifyTimer[index] = setInterval(() => {
    //         this.notifyStatus.title = item.fileOriginName
    //         this.notifyStatus.success = item.success
    //         this.notifyStatus.fail = item.fail
    //         this.notifyStatus.id = item.id
    //         this.notifyFunc(from)
    //         clearInterval(notifyTimer[index])
    //         console.log('this.filterArr header---', this.filterArr)
    //       }, 1000)
    //     })
    //   } else { // 正在上传
    //     this.notifyStatus.customClass = 'hide-close'
    //     this.notifyStatus.iconClass = 'el-icon-time'
    //     this.notifyStatus.type = ''
    //     this.notifyStatus.title = cacheSessionStorage.get('fileName')
    //     this.notifyFunc(from)
    //     this.apiTimerFunc()
    //   }
    // },
    // notifyFunc() { // from=api即为上传完成入口，反之为正在上传入口
    //   const titleTip = this.filterArr.length > 0 && from === 'api' ? '上传完成！' : '正在上传…'
    //   const message = this.filterArr.length > 0 && from === 'api' ? `<span>成功${this.notifyStatus.success}条，</span><strong>失败${this.notifyStatus.fail}条</strong><label onclick='gotoDetail()'>查看详情 ></label>` : this.notifyStatus.message
    //   this.notifyVal = this.$notify({
    //     title: '[' + this.notifyStatus.title + ']' + titleTip,
    //     dangerouslyUseHTMLString: true,
    //     message: message,
    //     customClass: this.notifyStatus.customClass,
    //     iconClass: this.notifyStatus.iconClass,
    //     type: this.notifyStatus.type,
    //     duration: 3000,
    //     onClose: this.noCloseFunc(from)
    //   })
    // },
    open() {
      this.notifyStatus.customClass = 'hide-close'
      this.notifyStatus.iconClass = 'el-icon-time'
      this.notifyStatus.type = ''
      this.notifyStatus.title = cacheSessionStorage.get('fileName')
      this.notifyFunc()
      this.apiTimerFunc()
    },
    notifyFunc() { // from=api即为上传完成入口，反之为正在上传入口
      // const titleTip = '正在上传…'
      // const message = this.notifyStatus.message
      this.notifyVal = this.$notify({
        // title: '[' + this.notifyStatus.title + ']' + titleTip,
        dangerouslyUseHTMLString: true,
        message: `<div class='title_info'><div class='overflow_flex'>正在上传文件</div></div><span>请您耐心等待</span>`,
        customClass: this.notifyStatus.customClass,
        iconClass: this.notifyStatus.iconClass,
        type: this.notifyStatus.type,
        duration: 2000,
        onClose: this.noCloseFunc()
      })
    },
    showHistory() {
      this.hasUploadShow = false
      this.showDrawer = true
    },
    noCloseFunc() {
      this.$root.isuploadFile = false
      // if (from === 'api') this.getUnconfirm()
    },
    hasUploadClose() {
      this.$root.isuploadFile = false
      this.hasUploadShow = false
      this.exceptionNum = 0
      // this.getUnconfirm()
      this.$root.isUpdateList = true
    },
    gotoDetail() {
      // this.$root.isuploadFile = false
      // this.notifyVal.close()
      // 修改日志状态
      request({
        url: '/api/v1/upload/confirm/' + this.detailId,
        method: 'PUT',
        hiddenLoading: true
      }).then((res) => {
      })
      // this.showDrawer = true
      if (this.detailInfo.abnormal === 0 && this.detailInfo.repeat === 0) return
      if (this.$refs.resultDialogRef) {
        this.$refs.resultDialogRef.show(this.detailId)
      }
      this.hasUploadClose()
    },
    apiTimerFunc() {
      const fileIdList = cacheSessionStorage.get('fileIdStorage')
      // 根据id查询文件上传状态：
      // FAIL("0","失败"), SUCCESS("1","成功"), INVALID("2","无效文件"),UN_PROCESSCED("3","未处理文件")
      request({
        url: '/api/v1/upload/log/status?fileIdList=' + fileIdList,
        method: 'GET',
        hiddenLoading: true
      }).then((res) => {
        if (!res) return
        // 剔除失败和无效数据，resNotFail只包含成功和未处理数据
        let resNotFail = res.filter((item) => item.status !== FAIL)
        resNotFail = resNotFail.filter((item) => item.status !== INVALID)
        // 剔除未处理数据，filterArr只有成功数据
        const filterArr = resNotFail.filter((item) => item.status !== UN_PROCESSCED)
        if (filterArr.length > 0) {
          // if (filterArr.length !== 1) this.unit = '个文件'
          const failList = res.filter((item) => item.status === FAIL)
          this.exceptionNum = failList.length
          // 展示上传成功弹窗
          this.detailId = res[0].id
          this.filesTotal = res.length
          this.detailInfo = res[0]
          // isFixed & isRowData 都是false为草单，isFixed为固定模板，isRowData为自定义
          if (!this.detailInfo.isFixed && !this.detailInfo.isRowData) {
            this.unit = '个文件'
          } else {
            this.unit = '条'
          }
          this.getUnconfirm()
          setTimeout(() => {
            this.hasUploadShow = true
            this.$root.isUpdateList = true
          }, 5000)
          return
          // setTimeout(() => this.open('api'), 3000)
          // 剔除已展示过上传完成弹窗的id，下次api不再查询
          // this.filterArr.forEach((item) => {
          //   const idx = this.fileIdList.indexOf(item.id)
          //   this.fileIdList.splice(idx, idx > -1 ? 1 : 0)
          // })
        }
        // if (this.filterArr.length === resNotFail.length) {
        //   // 当所有数据都处理成功才停止调用api
        //   return
        // }
        // 尚未上传成功，继续调用api
        this.apiTimer = setTimeout(() => {
          this.apiTimerFunc()
        }, 3000)
      }).catch((res) => {
        ElMessage({ message: res.message, iconClass: 'el-icon-warning-outline', grouping: true })
      })
    },
    showDrawerFunc() {
      this.showDrawer = true
    },
    logout() {
      this.$emit('showlogout', true)
    },
    modifyPsw() {
      this.$emit('modifyPsw', true)
    },
    changeShowDrawer(val) {
      this.showDrawer = val
      this.$root.isHistory = false
    },
    getUnconfirm() {
      // 查看用户未确认
      request({
        url: '/api/v1/upload/query/log/un/confirm/num',
        method: 'GET',
        hiddenLoading: true
      }).then((data) => {
        this.unconfirmValue = data
      }).catch(err => {
        console.log(err)
      })
    },
    drawerClosed() {
      this.$root.isHistory = false
      this.showDrawer = false
      this.getUnconfirm()
    },
    getTotalString() {
      if (!this.detailInfo) return '本次上传0个文件；'
      if (this.detailInfo.isFixed || this.detailInfo.isRowData) {
        return `本次上传${this.detailInfo.success + this.detailInfo.repeat + this.detailInfo.abnormal}条；`
      }
      return `本次上传${this.detailInfo.success + this.detailInfo.repeat + this.detailInfo.abnormal}个文件；`
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/styles/variables.module.scss";

  .ups-header--container {
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    background: $headerBg;
    .ups-header--left, .ups-header--right {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
    }
    .ups-header__logo {
      width: 48px;
      height: 48px;
      border: none;
      outline: none;
    }
    .ups-header__title {
      margin-left: 30px;
      color: #FFFFFF;
      font-size: 24px;
      font-weight: bold;
    }
    .ups-header__search {
      margin-right: 20px;
    }
    .ups-header__user {
      margin-right: 10px;
      background: rgba(0, 0, 0, 0.15);
      width: 36px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border-radius: 50%;
      .ups-header__user-icon {
        font-size: 20px;
        color: #FFFFFF;
      }
    }
    .ups-header__department {
      font-size: 14px;
      color: #fff;
    }
    .vertical-line {
      margin: 0 12px;
      height: 16px;
      border-left: 1px solid #fff;
    }
    .ups-header__logout {
      padding: 4px 6px;
      padding-left: 0;
      font-size: 14px;
      color: #FFFFFF;
      cursor: pointer;
    }
    .info-popover{

      .icon{
        width: 16px;
        height: 16px;
      }
    }
  }
  .has-upload {
    width: 580px;
    position: absolute;
    right: 16px;
    top: 20px;
    box-shadow: 0px 15px 32px -3px rgba(0,0,0,0.08), 0px 4px 12px -2px rgba(0,0,0,0.08), 0px 2px 6px 0px rgba(0,0,0,0.06);
    border-radius: 4px 4px 4px 4px;
    background: #fff;
    padding: 16px;
    z-index: 9999;
    .flex-info {
      display: flex;
      align-items: center;
    }
    .success-icon {
      width: 32px;
      height: 32px;
      margin-right: 12px;
    }
    .success-text {
      font-size: 16px;
      font-family: Roboto-Medium, Roboto;
      font-weight: bold;
      color: #363636;
      line-height: 20px;
    }
    .success_p {
      padding-top: 5px;
      color: #757575;
    }
    .has-upload_content {
      font-family: PingFangSC, PingFangSC-Medium;
      color: #757575;
      margin: 4px 0 0 0;
      line-height: 20px;
      font-size: 14px;
      justify-content: space-between;
      strong {
        color: #DF2901;
        font-weight: normal;
      }
      .detail-btn {
        color: #0662BB;
        cursor: pointer;
        position: absolute;
        right: 16px;
        font-weight: bold;
      }
      .detail-btn-disable{
        color: #BFB8AF;
        pointer-events: none;
        position: absolute;
        right: 16px;
        font-weight: bold;
      }
      .detail-icon {
        width: 16px;
        height: 16px;
        margin-left: 6px;
      }
    }
    .has-upload_close {
      width: 32px;
      height: 32px;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .btm_info {
      color: #757575;
      line-height: 24px;
      span {
        text-decoration: underline;
        cursor: pointer;
        color: #0662BB;
      }
    }
  }
  .has-upload-draft {
    width: 530px;
  }
  .ups-header-popover {
    .ups-header--right-name {
      display: flex;
      align-items: center;
      margin-top: 8px;
      margin-left: 8px
    }
    .ups-header--right-email {
      margin-top: 15px;
      display: flex;
      align-items: center;
      margin-left: 8px;
    }
    .righr-img {
      height: 16px;
      width: 16px;
      margin-right: 20px;
    }
    .righr-label {
      font-size: 12px;
      color: #666666;
      display: inline-block;
      width: 50px;
    }
    .right-staff {
      font-size: 12px;
      color: #212121;
    }
    .ups-header--right-line {
      border-bottom: 1px solid #F2F2F2;
      margin: 15px 8px;
    }
    .ups-header--right-link {
      text-align: center;
      width: 100%;
      height: 20px;
      font-size: 12px;
      display:inline-block;
      color: #7191BE;
    }
    .ups-header--right-img {
      width: 36px;
      height: 36px;
      margin-right: 15px;
    }
    .item-tooltip-content {
      text-align: center;
      .item-tooltip-label {
        font-size: 14px;
        color: #FFFFFF;
      }
      .item-tooltip-data {
        font-size: 12px;
        color: #AAAAAA;
      }
   }
  }
  .ups-header--right-img {
    width: 36px;
    height: 36px;
    margin-right: 15px;
  }
</style>
<style lang="scss">
.hide-close {
  width: 208px !important;
  .el-notification__closeBtn {
    display: none;
  }
  .el-icon-success {
    background: url("../../assets/img/customer/icon_waiting@2x.png") no-repeat;
    background-size: 24px 24px;
  }
  .el-icon-success:before {
    content: "";
  }
  .el-notification__content {
    .title_info {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      color: #363636;
      line-height: 20px;
    }
    .overflow_flex {
      display: flex;
      align-items: center;
    }
    .overflow_info {
      max-width: 206px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span {
      padding-top: 4px;
      font-size: 14px;
      color: #757575;
      display: inline-block;
    }
  }
}
.show-close {
  .el-notification__closeBtn {
    top: 12px;
    right: 12px;
    color: #757575;
  }
  .el-notification__content {
    font-family: PingFangSC, PingFangSC-Medium;
    color: #757575;
    margin: 10px 0 0 0;
    strong {
      color: #DF2901;
      font-weight: normal;
      padding-right: 70px;
    }
    label {
      color: #0662BB;
      cursor: pointer;
      position: absolute;
      right: 16px;
      font-weight: bold;
    }
  }
  .el-icon-success {
    color: #00857D;
  }
}
.show-close, .hide-close {
  width: 384px;
  border-radius: 5px;
  .el-notification__title {
    color: #363636;
  }
}
.show-close .el-icon-success, .hide-close .el-icon-success {
  margin-top: 10px;
}
.el-notification__icon {
  margin-top: 16px;
}
.upload-icon {
  color: #fff;
  cursor: pointer;
  padding: 0 4px;
  .el-icon-upload2 {
    width: 24px;
    line-height: 24px;
    text-align: center;
  }
  .el-badge__content {
    background-color: #DF2901;
    border: 1px solid #DF2901;
    height: 14px;
    line-height: 14px;
    padding: 0 4px;
    border-radius: 20px;
  }
}
.upload-icon:hover {
  background: #016862;
}
.drawer-details {
  padding: 0 32px 0;
  margin-bottom: 75px;
  border-bottom: 1px solid #F2F2F2;
  overflow: hidden;
}
.ups-header--container {
  .el-drawer__header {
    font-size: 16px;
    color: #363636;
    font-weight: bold;
    padding: 32px 0 0 32px;
    margin-bottom: 26px;
  }
  .el-drawer__close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .el-drawer.rtl {
    // width: 33.3% !important;
    min-width: 486px;
  }
}
</style>
